export default "__VITE_ASSET__Cat5afDc__"